import { searchRegulatedInformation } from '../helpers/filters/regulated-information';
import { search } from './search';

export const FILTER_REGULATED_INFORMATION_KEY = 'regulated-information-filter';
export const searchRegulatedInformations = search(searchRegulatedInformation);
